import { fileUrl, serverFetch } from '@server';
import { useEffect, useState } from 'react';

const ORG_FORMS = new Set(['ооо', 'ип', 'зао', 'оао', 'пао', 'ао', 'нко', 'ано', 'гуп', 'муп']);

// Одна буква, если в названии одно слово, иначе первые буквы двух первых слов.
export const companyInitials = (name) => {
    const words = String(name ?? '')
        .replace(/\([^)]*\)/g, ' ')
        .replace(/[«»"'`.,()]/g, ' ')
        .split(/\s+/)
        .map((word) => word.replace(/^[^0-9A-Za-zА-Яа-яЁё]+|[^0-9A-Za-zА-Яа-яЁё]+$/g, ''))
        .filter(Boolean);
    const meaningful = words.filter((word) => !ORG_FORMS.has(word.toLowerCase()));
    const use = meaningful.length > 0 ? meaningful : words;
    if (use.length === 0) return '';
    const first = use[0].charAt(0).toLocaleUpperCase('ru');
    if (use.length === 1) return first;
    return first + use[1].charAt(0).toLocaleUpperCase('ru');
};

export const LogoSlot = ({ fileId, name, size = 64, empty = false }) => {
    const style = {
        width: size,
        height: size,
        borderRadius: size >= 64 ? undefined : Math.round(size * 0.28),
    };
    if (fileId) {
        return (
            <img
                className="ca-logo-slot"
                style={style}
                src={fileUrl(fileId, true)}
                alt=""
                width={size}
                height={size}
            />
        );
    }
    const letters = companyInitials(name);
    if (!letters) {
        if (!empty) return null;
        return <span className="ca-logo-slot ca-logo-fallback" style={style} />;
    }
    const one = letters.length === 1;
    return (
        <span
            className={`ca-logo-slot ca-logo-fallback${one ? ' ca-logo-fallback-one' : ''}`}
            style={{ ...style, fontSize: Math.round(size * (one ? 0.42 : 0.32)) }}
        >
            {letters}
        </span>
    );
};

// Логотип компании контрагента. Для уже загруженной задачи или заказа хватает preset*,
// иначе карточка контрагента запрашивается, а у контакта берётся логотип родительской компании.
export const useContragentLogo = (contragentId, presetId, presetFileId, presetName) => {
    const [logo, setLogo] = useState({ fileId: null, name: '' });

    useEffect(() => {
        if (!contragentId) {
            setLogo({ fileId: null, name: '' });
            return undefined;
        }
        if (presetId === contragentId && presetName) {
            setLogo({ fileId: presetFileId ?? null, name: presetName });
            return undefined;
        }
        let cancelled = false;
        serverFetch(`contragent/${contragentId}`)
            .then((contragent) => {
                if (contragent.vid === 1 || !contragent.parentId) return contragent;
                return serverFetch(`contragent/${contragent.parentId}`)
                    .then((parent) => ({
                        logoFileId: parent.logoFileId ?? contragent.logoFileId,
                        name: parent.name || contragent.name,
                    }))
                    .catch(() => contragent);
            })
            .then((contragent) => {
                if (!cancelled) setLogo({ fileId: contragent.logoFileId ?? null, name: contragent.name || '' });
            })
            .catch(() => {
                if (!cancelled) setLogo({ fileId: null, name: '' });
            });
        return () => { cancelled = true; };
    }, [contragentId, presetId, presetFileId, presetName]);

    return logo;
};
